import { NodeViewWrapper } from '@tiptap/react';

export default function YoutubeNodeView({ node, selected }) {
  return (
    <NodeViewWrapper>
      <div className={`post-video border-2 rounded transition-colors ${selected ? 'border-bahyellow' : 'border-transparent'}`}>
        <iframe
          width="560"
          height="315"
          src={node.attrs.src}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </NodeViewWrapper>
  );
}
